import { useQuery } from "@tanstack/react-query";
import { useGetCurrentUserQuery } from "../users";
import { onboardingApi } from "./onboarding.api";
import { onboardingKeys } from "./onboarding.keys";

let settledUserId: string | null = null;

/**
 * Set by the sidebar once the user has finished every onboarding task or hidden the
 * onboarding card. The state is then read once per page load instead of on every page and
 * save. It is still read once: the welcome modal, the editor tour (an admin can turn the
 * onboarding on again) and the deck placeholders depend on it.
 */
export const setOnboardingSettled = (userId: string | null) => {
  settledUserId = userId;
};

const isOnboardingSettled = (userId: string | null | undefined) =>
  !!userId && settledUserId === userId;

/**
 * `enabled` is the caller's onboarding-cohort check: GET /onboarding/me runs backfills and
 * HubSpot lookups server-side, so users outside the onboarding must never call it.
 */
export const useGetOnboardingStateQuery = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const { data: me } = useGetCurrentUserQuery();
  return useQuery({
    queryKey: [...onboardingKeys.state, me?._id ?? null],
    queryFn: () => onboardingApi.getState(),
    enabled: enabled && !!me?._id,
    staleTime: () => (isOnboardingSettled(me?._id) ? Infinity : 30_000),
    refetchInterval: (query) =>
      (query.state.data?.starterDecks?.pending ?? 0) > 0 ? 10_000 : false,
  });
};
